<script>
import date from '@/mixins/date'
import ListingResource from '@/resources/listing'
import JobPostingForm from '@/components/JobPostingForm.vue'

export default {
    name: 'RecruitJob',
    components: {
        JobPostingForm,
    },
    mixins: [date],
    data() {
        return {
            loading: true,
            listingResource: null,
        }
    },
    props: {
        companyResource: {
            type: Object,
        },
    },
    methods: {
        async onSubmit() {
            await this.listingResource.save()
            this.$router.push({ name: 'recruitJobView', params: { companyId: this.companyResource.id, listingId: this.listingResource.id } })
        }
    },
    async mounted() {
        let listingId = this.$route.params.listingId
        this.listingResource = await ListingResource.detail(listingId, { resolveRelated: true })
        this.loading = false
    },
}
</script>

<template>
    <b-row v-page-title="'Edit Job'">
        <b-col md="9">
            <job-posting-form
                v-if="!loading"
                :listing-resource="listingResource"
                :company-resource="companyResource"
                :user-resource="$store.getters.userResource"
                @success="onSubmit">
            </job-posting-form>

            <p v-else>Loading...</p>
        </b-col>
    </b-row>
</template>

<style lang="scss"></style>
